document.addEventListener("DOMContentLoaded", function() {
  if (!window.product) return; // ensures the product exists

  var ccs_cc_args = ccs_cc_args || [];

  // Shopify Liquid dynamically outputs product values
  ccs_cc_args.push(['mf', '{{ product.vendor | escape }}']); // Manufacturer
  ccs_cc_args.push(['pn', '{{ product.metafields.custom.one_world_sync | escape }}']); // Manufacturer Part Number
  ccs_cc_args.push(['upcean', '{{ product.barcode | escape }}']); // Barcode
  ccs_cc_args.push(['lang', 'EN']);
  ccs_cc_args.push(['market', 'GB']);

  (function () {
    var o = ccs_cc_args;
    o.push(['_SKey', '3897eb08']);
    o.push(['_ZoneId', '64ab72da30']);

    var sc = document.createElement('script');
    sc.type = 'text/javascript';
    sc.async = true;
    sc.src = 'https://cdn.cs.1worldsync.com/jsc/h1ws.js';

    document.getElementsByTagName('head')[0].appendChild(sc);
  })();
});
